module.exports = __webpack_public_path__ + "img/平台架构@2x.d6f0a6f6.png";